<template>
    <th class="j-table-head-col">
        <slot></slot>
    </th>
</template>